import { render, staticRenderFns } from "./SellTogether.vue?vue&type=template&id=5051af5f&"
import script from "./SellTogether.vue?vue&type=script&lang=js&"
export * from "./SellTogether.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports